/* unplugin-vue-components disabled */import script from "./DynamicParams.vue?vue&type=script&setup=true&lang=js"
export * from "./DynamicParams.vue?vue&type=script&setup=true&lang=js"

import "./DynamicParams.vue?vue&type=style&index=0&id=737ab2de&lang=scss"

const __exports__ = script;

export default __exports__